import { FC } from "react";
import { PhotoIcon } from "@heroicons/react/24/outline";

/**
 * The car's photo in a booking card, or, when it has none, a tile that can be seen on the card (1NOW-11204).
 * `bg-secondary-100` is the card's own colour in Design B's dark palette, so the tile there takes a tint of
 * the text colour instead, which is lighter than a dark card and darker than a light one.
 */
const CarPhoto: FC<{ photo?: string | null; className: string }> = ({ photo, className }) =>
  photo ? (
    <img src={photo} alt="" className={`${className} shrink-0 object-cover`} />
  ) : (
    <span
      aria-hidden="true"
      data-testid="car-photo-placeholder"
      className={`${className} flex shrink-0 items-center justify-center bg-secondary-100 text-text-color/40 [.design-b_&]:bg-text-color/10`}
    >
      <PhotoIcon className="h-6 w-6" />
    </span>
  );

export default CarPhoto;
